import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ThirdPartyForm_Organization_Fragment = graphql(`
  fragment ThirdPartyForm_Organization_Fragment on Organization {
    # technical fields
    _id
    typeId
    kind
    isInternal
    statusId
    codingConfig {
      strategyId
      kind
    }
    code

    # general info
    internalMemo
    memo
    categoryIds
    birthDate
    isVip
    color
    categoryIds
    identifier {
      _id
      kind
      value
    }
    vatNumber
    shareCapital {
      _id
      value
      currencyId
    }
    name
    nafId
    tradingName
    legalStatusId
    activity
    logoImageUri

    # contact info
    contactInfo {
      _id
      email
      faxNumber
      landlineNumber
      mobileNumber
      professionalNumber
      website
    }

    # addresses
    addresses {
      _id
      typeIds
      postalInfo {
        _id
        postOfficeBox
        postalCode
        region
        route
        streetNumber
        additional
        building
        businessPostCode {
          postalCode
          distributorOfficeNumber
        }
        locality
        inseeCode
        department
        countryAlpha2
      }
      locationInfo {
        _id
        coordinates
        projectionId
        altitude
      }
      cadastralInfo {
        _id
        departmentCode
        districtCode
        municipalityCode
        number
        oldMunicipalityCode
        section
        sheet
      }
      ...AddressesCmp_Address_Fragment
      ...AddressForm_Address_Fragment
    }

    # quotation emitters
    billEmitterIds

    # quotation receiver
    billReceiverId

    # bank info
    bankInfo {
      _id
      accountOwner
      accountNumber
      bankCode
      branchCode
      certificateKey
      domiciliation
      iban
      swift
    }

    # organization active memberships
    activeMemberships {
      _id
      personId
      functions
      contextualRoleIds
      representativeTypeIds
    }

    # mother organization
    motherId

    # child organizations
    childIds

    ...ThirdPartyForm_OrganizationGeneralInfoStep_Organization_Fragment
    ...ThirdPartyForm_ContactInfoStep_ThirdParty_Fragment
    ...ThirdPartyForm_AddressesStep_ThirdParty_Fragment
    ...ThirdPartyForm_BillEmittersStep_ThirdParty_Fragment
    ...ThirdPartyForm_BillReceiverStep_ThirdParty_Fragment
    ...ThirdPartyForm_BankInfoStep_ThirdParty_Fragment
    ...ThirdPartyForm_OrganizationMembershipsStep_Organization_Fragment
    ...ThirdPartyForm_OrganizationMembershipsDetailsStep_Organization_Fragment
    ...ThirdPartyForm_MotherOrganizationStep_Organization_Fragment
    ...ThirdPartyForm_ChildOrganizationsStep_Organization_Fragment
  }
`);

export type ThirdPartyForm_Organization = ResultOf<
  typeof ThirdPartyForm_Organization_Fragment
>;
